import React from 'react';
import { motion } from 'framer-motion';
import siteConfig from'../config/siteConfig'
import useMeta from "../hooks/useMeta";


function Contact() {
  const email = "satyamjha@jointerx.com"; 

  const copyToClipboard = () => {
    navigator.clipboard.writeText(email);
    alert("Email copied to clipboard!");
  };

   useMeta({
    title: "Contact | Satyam Jha",
    description: "Get in touch with Satyam Jha for collaborations, opportunities, or queries related to Android and Spring Boot development.",
    keywords: "Contact Satyam Jha, get in touch, connect, Android developer, Spring Boot developer, hire developer"
    ,canonical: "https://satyamjha.in/contact"
  });
  return (
  
    <div className="min-h-screen bg-gradient-to-br dark:from-gray-800 dark:to-gray-900 flex flex-col justify-center items-center px-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full bg-[#f1f1f1] dark:bg-gray-700 rounded-xl shadow-lg p-8 text-center"
      >
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">Let's Connect</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-8">
          Have a project in mind or want to collaborate? Feel free to reach out!
        </p>

        <div className="group relative">
          <div 
            onClick={copyToClipboard}
            className="bg-blue-100 dark:bg-gray-600 p-4  rounded-lg cursor-pointer transition-all duration-300 hover:bg-blue-200 dark:hover:bg-gray-500"
          >
            <div className="flex items-center justify-center  space-x-3 ">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span className="text-md md:text-lg lg:text-lg font-mono text-blue-600 dark:text-blue-400">{email}</span>
            </div>
          </div>
          <span className="absolute -bottom-6 left-0 right-0 text-center text-sm text-gray-500 dark:text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity">
            Click to copy
          </span>
        </div>

        <div className="mt-12">
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            Prefer social media? Find me on:
          </p>
          <div className="flex justify-center space-x-4 mt-2">
           
            <a href={siteConfig.social.linkedin} className="text-gray-600 dark:text-gray-300 hover:text-blue-500 dark:hover:text-blue-400">
              <span className="sr-only">LinkedIn</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
              </svg>
            </a>
            {/*Instagram*/}
                          <a
                             target="_blank"
                            href={siteConfig.social.instagram}
                            className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
                          >
                            <span className="sr-only">Instagram</span>
                            <svg
                
                              className="h-6 w-6"
                              fill="currentColor"
                              viewBox="0 0 640 640"
                              aria-hidden="true"
                            >
                              <path
                                fillRule="evenodd"
                                d="M320.3 205C256.8 204.8 205.2 256.2 205 319.7C204.8 383.2 256.2 434.8 319.7 435C383.2 435.2 434.8 383.8 435 320.3C435.2 256.8 383.8 205.2 320.3 205zM319.7 245.4C360.9 245.2 394.4 278.5 394.6 319.7C394.8 360.9 361.5 394.4 320.3 394.6C279.1 394.8 245.6 361.5 245.4 320.3C245.2 279.1 278.5 245.6 319.7 245.4zM413.1 200.3C413.1 185.5 425.1 173.5 439.9 173.5C454.7 173.5 466.7 185.5 466.7 200.3C466.7 215.1 454.7 227.1 439.9 227.1C425.1 227.1 413.1 215.1 413.1 200.3zM542.8 227.5C541.1 191.6 532.9 159.8 506.6 133.6C480.4 107.4 448.6 99.2 412.7 97.4C375.7 95.3 264.8 95.3 227.8 97.4C192 99.1 160.2 107.3 133.9 133.5C107.6 159.7 99.5 191.5 97.7 227.4C95.6 264.4 95.6 375.3 97.7 412.3C99.4 448.2 107.6 480 133.9 506.2C160.2 532.4 191.9 540.6 227.8 542.4C264.8 544.5 375.7 544.5 412.7 542.4C448.6 540.7 480.4 532.5 506.6 506.2C532.8 480 541 448.2 542.8 412.3C544.9 375.3 544.9 264.5 542.8 227.5zM495 452C487.2 471.6 472.1 486.7 452.4 494.6C422.9 506.3 352.9 503.6 320.3 503.6C287.7 503.6 217.6 506.2 188.2 494.6C168.6 486.8 153.5 471.7 145.6 452C133.9 422.5 136.6 352.5 136.6 319.9C136.6 287.3 134 217.2 145.6 187.8C153.4 168.2 168.5 153.1 188.2 145.2C217.7 133.5 287.7 136.2 320.3 136.2C352.9 136.2 423 133.6 452.4 145.2C472 153 487.1 168.1 495 187.8C506.7 217.3 504 287.3 504 319.9C504 352.5 506.7 422.6 495 452z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </a>
            <a href={siteConfig.social.github} className="text-gray-600 dark:text-gray-300 hover:text-blue-500 dark:hover:text-blue-400">
              <span className="sr-only">GitHub</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
              </svg>
              
            </a>
              {/*Play Store*/}
              <a
                href={siteConfig.social.playstore}
                className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
              >
                <span className="sr-only">Google Play Store</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <path d="M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055zM1 13.396V2.603L6.846 8zM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27" />
                </svg>
              </a>
              {/*LeetCode*/}
              <a
                href={siteConfig.social.leetcode}
                className="text-gray-800 dark:text-gray-200 hover:text-blue-500 dark:hover:text-blue-400"
              >
                <span className="sr-only">LeetCode</span>
                 <svg  className="h-6 w-6" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24.000000 24.000000"  preserveAspectRatio="xMidYMid meet">  <g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none"> <path d="M77 181 c-70 -73 -72 -95 -17 -145 47 -42 60 -44 97 -12 43 37 19 48 -29 14 -15 -10 -22 -8 -48 17 -38 36 -38 57 1 89 30 26 56 24 74 -4 9 -15 25 -12 25 5 0 8 -11 22 -25 31 -23 15 -24 18 -10 34 14 15 11 30 -5 30 -4 0 -32 -27 -63 -59z"/> <path d="M97 104 c-15 -15 8 -24 64 -24 46 0 59 3 59 15 0 12 -13 15 -58 15 -32 0 -62 -3 -65 -6z"/> </g> </svg> 

              </a>
          </div>
        </div>
      </motion.div>
    </div>
  
  );
}

export default Contact;